export const WIDGET_TYPES = {
  LINE: 'line',
  BAR: 'bar',
  PIE: 'pie',
  TABLE: 'table',
  SINGLE: 'single',
  TITLE: 'titleWidget',
  FILTER_DATE: 'filter-date',
  FILTER_DROPDOWN: 'filter-dropdown',
  FILTER_DROPDOWN_PHARMLOCATION: 'filter-dropdown-pharmlocation',
  PATIENT_FORMS: 'patientForms'
};

export const FILTER_WIDGET_TYPES = new Set([
  WIDGET_TYPES.FILTER_DATE,
  WIDGET_TYPES.FILTER_DROPDOWN,
  WIDGET_TYPES.FILTER_DROPDOWN_PHARMLOCATION
]);

export function getWidgetType(widget) {
  if (!widget || typeof widget !== 'object') {
    return '';
  }
  return widget.widget || widget.type || '';
}

export function isFilterWidget(widget) {
  return FILTER_WIDGET_TYPES.has(getWidgetType(widget));
}
